<template lang="html">
    <!-- layout of the app  -->
    <div class="app-layout">
        <!-- put every major component of the app, like nav, header, aside modals, file viewer -->
        <app-nav></app-nav>

        <div class="app-body" id="scroll-target">
            <app-header></app-header>
            <app-content></app-content>
        </div>

        <app-aside></app-aside>

        <app-snackbar></app-snackbar>

        <app-modal></app-modal>
        <app-modal2></app-modal2>

        <view-files></view-files>

    </div>
</template>

<script>
    import AppContent   from './Content'
    import AppHeader    from './Header'
    import AppNav       from './Nav'
    import AppAside     from './Aside'
    import AppSnackbar  from './Snackbar'
    import AppModal     from './Modal'
    import AppModal2    from './Modal2'
    import ViewFiles    from '../../components/files/ViewFiles'

    export default {
        components: { AppContent, AppHeader, AppNav, AppAside, AppModal, AppModal2, AppSnackbar,ViewFiles}
    }
</script>

<style lang="stylus" scoped>
    @require '../../assets/css/variables'

    div.app-layout {
        display: flex

        div.app-body {
            display: flex
            flex-direction: column
            height: $app-body-height
            width: $app-body-width
            padding: $app-header-height 0 0
            font-family: 'Muli', sans-serif
            letter-spacing: -0.43px
            color: $text-color
            background: $app-content-background
            overflow-y: auto
            z-index: 1

            &::-webkit-scrollbar { width: 0 !important }
        }
    }
</style>



// WEBPACK FOOTER //
// src/layouts/app/Layout.vue